import ApiClient from './ApiClient';

class SourceRecoveryAPI extends ApiClient {
  constructor() {
    super('source_recovery', { accountScoped: true });
  }

  status() { return axios.get(`${this.url}/status`); }
  reconnect(id) { return axios.post(`${this.url}/reconnect`, { id }); }
  password(id, password) { return axios.post(`${this.url}/password`, { id, password }); }
}

export default new SourceRecoveryAPI();
